import { render, staticRenderFns } from "./ProjectDocumentTemplateListing.vue?vue&type=template&id=21619418&"
import script from "./ProjectDocumentTemplateListing.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentTemplateListing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocumentTemplateListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports